import { TICKS } from "./config";
import { Entity } from "./Entity";
import { EntityElement } from "./EntityElement";

export class EntityRenderer extends AbortController {
  elements = new Map<Entity, EntityElement>();
  interval: number;

  constructor(readonly entities: Set<Entity>) {
    super();
    requestAnimationFrame(this.render.bind(this));
    this.interval = setInterval(this.step.bind(this), 1000 / TICKS);
  }

  abort() {
    super.abort();
    clearInterval(this.interval);
    for (const element of this.elements.values()) element.remove();
  }

  render() {
    if (this.signal.aborted) return;
    requestAnimationFrame(this.render.bind(this));
    for (const element of this.elements.values()) element.render();
  }

  step() {
    this.createElements();
    this.deleteElements();
  }

  createElements() {
    for (const entity of this.entities) {
      if (this.elements.has(entity)) continue;
      const element = new EntityElement(entity);
      document.body.append(element);
      this.elements.set(entity, element);
    }
  }

  deleteElements() {
    for (const [entity, element] of this.elements) {
      if (this.entities.has(entity)) continue;
      element.remove();
      this.elements.delete(entity);
    }
  }
}
